<template>
  <layout-content>
    <i-button
      slot="top-buttons"
      type="primary"
      size="large"
      :to="{ name: 'pbx.phone-list.create' }"
    >
      {{ $t('pbx.breadcrumb.phone-list.create') }}
    </i-button>

    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import FilterComponent from '@pbx/components/phone-lists/list/filter';
  import TableComponent from '@pbx/components/phone-lists/list/table';
  export default {
    components: {
      FilterComponent,
      TableComponent
    }
  };
</script>
